import { FaGlobe, FaUsers, FaRobot, FaClipboardCheck } from 'react-icons/fa';

const counter = [
    {
        id: 1,
        icon: <FaGlobe />, // Globe icon for global impact
        title: 'Global Impact',
        count: '45',
    },
    {
        id: 2,
        icon: <FaUsers />, // Users icon for clients served
        title: 'Clients Served',
        count: '1500',
    },
    {
        id: 3,
        icon: <FaRobot />, // Robot icon for AI solutions
        title: 'Solution Delivered',
        count: '500',
    },
    {
        id: 4,
        icon: <FaClipboardCheck />, // Clipboard icon for projects completed
        title: 'Projects Completed',
        count: '120',
    },
];

export default counter;